import { humanizeEnum } from '../utils/humanizeEnum';

export enum VehicleTypes {
  BUS = 'bus',
  CAR = 'car',
  MOTORCYCLE = 'motorcycle',
  OTHER = 'other',
  SUV = 'suv',
  THREE_WHEELER = 'three_wheeler',
  TROLLEY = 'trolley',
  TRUCK = 'truck',
}

export enum DetectionVehicleTypes {
  CAR = 1,
  TRUCK = 2,
  BUS = 3,
  MOTORCYCLE = 4,
}

export const VEHICLE_TYPE_OPTIONS = Object.values(VehicleTypes).map((v) => ({
  value: v,
  label: humanizeEnum(v),
}));

export enum VehicleClasses {
  BUS = 'BUS',
  AMBULANCE = 'AMBULANCE',
  POLICE = 'POLICE',
  UPS = 'UPS',
  FEDEX = 'FEDEX',
  OTHER = 'OTHER',
}

export const VehicleClassOptions: Record<VehicleClasses, { label: string; internalOnly: boolean }> = {
  [VehicleClasses.BUS]: { label: 'Bus', internalOnly: false },
  [VehicleClasses.AMBULANCE]: { label: 'Ambulance', internalOnly: false },
  [VehicleClasses.POLICE]: { label: 'Police', internalOnly: false },
  [VehicleClasses.UPS]: { label: 'UPS', internalOnly: false },
  [VehicleClasses.FEDEX]: { label: 'FedEx', internalOnly: false },
  [VehicleClasses.OTHER]: { label: 'Other', internalOnly: true },
};
